<!--
 * @Author: hzm
 * @Date: 2024-04-22 10:17:57
 * @Description: 物资收发登记卡 [250张/组]
-->
<template>
  <span class="text-[#FE7036] text-14px" style="white-space: nowrap;"  >{{ handlePoint }}<span class="text-14px">积分</span>
  </span>
</template>

<script setup lang="ts">
const props = defineProps({
  point: {
    type: Number,
  },
});
const handlePoint = computed(() => {
  return million(props.point)
})



function million(value) {
  if (!value) return 0;
  if (typeof value == 'string') {
    value = Number(value);
  }
  let unit = '';
  const k = 10000;
  const sizes = ['', '万','十万','百万','千万','亿'];
  let i;
  if (value < k) {
    return value;
  } else {
    i = Math.floor(Math.log(value) / Math.log(k)); // 单位下标
    value = value / Math.pow(k, i);
    value = (parseInt(value * 100) / 100).toFixed(2);
    unit = sizes[i];
  }
  return value + unit || 0;
}

</script>

<style scoped>

</style>
